var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailNoAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "39px",
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nope") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nope",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke-193-+-Stroke-194-+-Stroke-195",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#D21028"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,18.5 C37,28.7153636 28.7153636,37 18.5,37 C8.28127273,37 0,28.7153636 0,18.5 C0,8.28127273 8.28127273,0 18.5,0 C28.7153636,0 37,8.28127273 37,18.5 L37,18.5 Z",
    id: "Stroke-193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,26 L26,11",
    id: "Stroke-194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,11 L26,26",
    id: "Stroke-195"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailNoAnimation);
export default __webpack_public_path__ + "static/media/fail_no_animation.e81b76124421af5945e9f167ef5d3220.svg";
export { ForwardRef as ReactComponent };